import { Button, Form, message, Modal, Select } from 'antd';
import React, { useState } from 'react';

import axiosWithAuth from '@/lib/axios';

import { Locker } from '../types';

const { Item, useForm, useWatch } = Form;

type FormValues = {
  id: string;
  status: string;
  houseNumber?: string;
};

const EditButtonWithModal: React.FC<{
  locker: Locker;
  houseNumbers: string[];
  mutate: () => void;
}> = ({ locker, houseNumbers, mutate }) => {
  const [open, setOpen] = useState(false);
  const [form] = useForm<FormValues>();

  const currentStatus = useWatch('status', form);

  const handleFinish = async (values: FormValues) => {
    try {
      await axiosWithAuth.patch('/ezcon/api/ultraLocker/backstageLockers', {
        ...values,
        lockerId: locker.id,
      });
      mutate();
      setOpen(false);
    } catch (e) {
      message.error('編輯櫃位失敗');
    }
  };

  return (
    <>
      <Button
        onClick={() => {
          setOpen(true);
          form.setFieldsValue(locker);
        }}
      >
        編輯
      </Button>
      <Modal
        open={open}
        onCancel={() => {
          setOpen(false);
          form.resetFields();
        }}
        onOk={form.submit}
        cancelButtonProps={{ type: 'primary' }}
        okButtonProps={{ type: 'default' }}
        closable
        title={`編輯櫃位 ${locker.name}`}
        centered
      >
        <Form form={form} onFinish={handleFinish} initialValues={locker}>
          <Item
            label="狀態"
            name="status"
            rules={[{ required: true, message: '狀態為必填' }]}
          >
            <Select
              options={['空櫃', '使用中', '故障'].map((status) => ({
                label: status,
                value: status,
              }))}
              placeholder="請選擇狀態"
              onChange={(value) => {
                if (value !== '使用中') {
                  form.setFieldsValue({ houseNumber: undefined });
                }
              }}
            />
          </Item>
          <Item
            label="收件戶號"
            name="houseNumber"
            rules={[
              () => {
                if (currentStatus === '使用中') {
                  return {
                    required: true,
                    message: '收件戶號為必填',
                  };
                }
                return {};
              },
            ]}
          >
            <Select
              options={houseNumbers.map((number) => ({
                label: number,
                value: number,
              }))}
              disabled={currentStatus !== '使用中'}
              placeholder="請選擇收件戶號"
            />
          </Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditButtonWithModal;
